<template>
    <ul class="list-group list-group-horizontal mt-3 font-size-1 border-bottom fw-semibold sticky-heading">
        <li class="list-group-item border-0 pb-3" :class="{ 'active-top': $route.name === 'FarmStayBookingList' }">
            <router-link to="/farm-stay/retreat/bookings">Booking List</router-link>
        </li>
        <li class="list-group-item border-0 pb-3" :class="{ 'active-top': $route.name === 'BookRetreat' }">
            <router-link :to="{ name: 'BookRetreat' }">Book cottage</router-link>
        </li>
        <li class="list-group-item border-0 pb-3" :class="{ 'active-top': $route.name === 'FarmStayList' }">
            <router-link to="/farm-stay/retreat">Retreats</router-link>
        </li>
        <li class="list-group-item border-0 pb-3" :class="{ 'active-top': $route.name === 'FarmStayCalender' }">
            <router-link to="/farm-stay/calender">Calendar</router-link>
        </li>
    </ul>
</template>
<style>
.sticky-heading {
    background-color: #ffffff;
    position: sticky;
}
</style>